export var LocalStorageItem;

(function (LocalStorageItem) {
  LocalStorageItem["ALL_COMPLETED_ORDERS"] = "allCompletedOrders";
})(LocalStorageItem || (LocalStorageItem = {}));